import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, memo, useCallback, useContext, useMemo, useRef } from "react";
const defaultValue = {
    getCurrentSearchResultElement: ()=>null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    clearElementForPage: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setCurrentSearchResultElement: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    subscribeToCurrentSearchResultElement: ()=>({
            unsubscribe: ()=>{}
        })
};
export const PDFCurrentSearchResultElementContext = /*#__PURE__*/ createContext(defaultValue);
export const PDFCurrentSearchResultElementContextProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const currentSearchResultElementRef = useRef(null);
    const subscribersRef = useRef(new Set());
    const getCurrentSearchResultElement = useCallback(()=>currentSearchResultElementRef.current, []);
    const setCurrentSearchResultElement = useCallback((element)=>{
        if (element !== currentSearchResultElementRef.current) {
            subscribersRef.current.forEach((subscriber)=>subscriber(element));
            currentSearchResultElementRef.current = element;
        }
    }, []);
    const subscribeToCurrentSearchResultElement = useCallback((callback)=>{
        const subscriber = (element)=>{
            callback(element);
        };
        subscribersRef.current.add(subscriber);
        return {
            unsubscribe: ()=>{
                subscribersRef.current.delete(subscriber);
            }
        };
    }, []);
    const clearElementForPage = useCallback((pageNumber)=>{
        var _currentSearchResultElementRef_current;
        if (((_currentSearchResultElementRef_current = currentSearchResultElementRef.current) === null || _currentSearchResultElementRef_current === void 0 ? void 0 : _currentSearchResultElementRef_current.pageNumber) === pageNumber) {
            setCurrentSearchResultElement(null);
        }
    }, [
        setCurrentSearchResultElement
    ]);
    const value = useMemo(()=>({
            getCurrentSearchResultElement,
            setCurrentSearchResultElement,
            subscribeToCurrentSearchResultElement,
            clearElementForPage
        }), [
        clearElementForPage,
        getCurrentSearchResultElement,
        setCurrentSearchResultElement,
        subscribeToCurrentSearchResultElement
    ]);
    return /*#__PURE__*/ _jsx(PDFCurrentSearchResultElementContext.Provider, {
        value: value,
        children: children
    });
});
PDFCurrentSearchResultElementContextProvider.displayName = "PDFCurrentSearchResultElementContextProvider";
export const usePDFCurrentSearchResultElementContext = ()=>{
    const context = useContext(PDFCurrentSearchResultElementContext);
    if (context === defaultValue) {
        throw new Error("usePDFCurrentSearchResultElementContext must be used within a PDFCurrentSearchResultElementContextProvider");
    }
    return context;
};
